import { render, staticRenderFns } from "./FaseFenologicaList.vue?vue&type=template&id=4c86f2c6&scoped=true"
import script from "./FaseFenologicaList.vue?vue&type=script&lang=js"
export * from "./FaseFenologicaList.vue?vue&type=script&lang=js"
import style0 from "./FaseFenologicaList.vue?vue&type=style&index=0&id=4c86f2c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c86f2c6",
  null
  
)

export default component.exports